import {CheckCircle2,X} from "lucide-react";
import styles from "./CadastroRealizado.module.scss";

interface ModalCadastroRealizadoProps{
  open:boolean;
  titulo?:string;
  mensagem:string;
  descricao:string;
  detalheLabel?:string;
  detalheValor?:string;
  textoBotao?:string;
  onClose:()=>void;
  onContinuar:()=>void;
}

export const CadastroRealizado=({
  open,
  titulo="Parabéns!",
  mensagem,
  descricao,
  detalheLabel,
  detalheValor,
  textoBotao="Continuar",
  onClose,
  onContinuar,
}:ModalCadastroRealizadoProps)=>{
  if(!open)return null;

  return(
    <div className={styles.page} onClick={onClose}>
      <div className={styles.containerRealizado} onClick={(event)=>event.stopPropagation()}>
        <button type="button" className={styles.fechar} onClick={onClose} aria-label="Fechar">
          <X size={20}/>
        </button>

        <div className={styles.iconeContainer}>
          <CheckCircle2 className={styles.iconSucesso} size={58} strokeWidth={1.8}/>
        </div>

        <h2 className={styles.title}>{titulo}</h2>
        <p className={styles.subtitulo}>{mensagem}</p>

        {detalheValor&&(
          <div className={styles.pedido}>
            {detalheLabel&&<span>{detalheLabel}</span>}
            <strong>{detalheValor}</strong>
          </div>
        )}

        <p className={styles.text}>{descricao}</p>

        <button type="button" className={styles.button} onClick={onContinuar}>
          {textoBotao}
        </button>

        <div className={styles.containerLogo}>
          <img className={styles.logoEmpresa} src="/imagens/logoCompra.png" alt="Logo"/>
        </div>
      </div>
    </div>
  );
};